import React, { useState, useContext } from 'react';

import { FlexDiv, GenericDiv, ResponsiveContainer, Headings, GenericP } from '../../../../common/Styles';
import { TabsElem, FeatureWrapper, ImgWrap } from './featuresStyles';
import ActionBtns from '../../../../bizLanding/components/actionButtons/actionButtons';

import { featuresData } from '../../config';
import { LANDING_CONSTS } from '../../../../AppConstants';
import { isMobileContext } from '../../../../UtilityComponents/Util';
import DisplayContext from '../../../../UtilityComponents/displayContext';

const Features = ({ isLoggedInUser = false }) => {
	const { tabs, data } = featuresData;
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	const [active, setActive] = useState(tabs[0].key);

	const updateActive = (e) => {
		const tabKey = e.target.dataset.tabkey;
		setActive(tabKey);
	};

	const activeData = data[active];
	const { imgSrc, heading, desc } = activeData;
	return (
		<FeatureWrapper id='Features'>
			<ResponsiveContainer>
				<FlexDiv justify='space-between' directionInMobile='column-reverse' position='relative'>
					<ImgWrap $width={isMobile ? '100%' : '48.5%'}>
						<img alt={heading} loading='lazy' height={isMobile ? '210' : 'auto'} src={imgSrc} />
					</ImgWrap>
					<GenericDiv $width={isMobile ? '100%' : '38%'}>
						<GenericDiv>
							{tabs.map((tab)=>(
								<TabsElem
									active={active === tab.key}
									onClick={updateActive}
									data-tabkey={tab.key}
									key={tab.key}>
									{tab.label}
								</TabsElem>
							))}
						</GenericDiv>
						<FlexDiv top_M={isMobile ? '32' : '66'} $direction='column' directionInMobile='column'>
							<Headings as={isMobile ? 'h3' : 'h1'} dangerouslySetInnerHTML={{ __html: heading }} />
							<GenericP fsize={isMobile ? '14px' : '18px'} top_M={isMobile ? '16' : '36'} bottom_M={isMobile ? '235' : '0'}>
								{desc}
							</GenericP>
							<GenericDiv $width={isMobile ? '100%' : '300px'} top_M='40'>
								<ActionBtns show={LANDING_CONSTS.SIGNUP} signupTxt={isLoggedInUser ? 'GET STARTED' : 'SIGN UP NOW'} />
							</GenericDiv>
						</FlexDiv>
					</GenericDiv>
				</FlexDiv>
			</ResponsiveContainer>
		</FeatureWrapper>
	);
};

export default Features;
